module.exports = __webpack_public_path__ + "static/img/image_recruit_01.4299dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_01.png
// module id = 4X5+
// module chunks = 10